import React, { useState, useEffect } from 'react'
import { ListGroup, Container, Row, Col } from 'react-bootstrap'
import Header from '../components/HeaderComponent'
import Footer from '../components/FooterComponent'
import Loading from '../components/LoadingComponent'

function SurahComponent({ match, location }) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const fetchData = async () => {
      try {
        import(`../db/surah${match.url}.json`)
          .then(res => setData(res.default))
          .then(() => setLoading(false))
      } catch (e) {

      }
    }
    fetchData()

    return function cleanup() {
      setLoading(true)
    }
  }, [match.url])

  useEffect(() => {
    window.scrollTo(0, 0)
  })

  let bismillah
  if ((match.params.surahName !== "al-fatihah") && (match.params.surahName !== "at-taubah")) {
    bismillah = <p className="arab surah-title">بِسْمِ اللّٰهِ الرَّحْمٰنِ الرَّحِيْمِ</p>
  }

  return (
    <>
      {
        loading ? <Loading /> : (
          <Container>
            <Row>
              <Col md={{ span: 6, offset: 3 }}>
                <Header />
                <h4 className="surah-title">Surat {match.params.surahName}</h4>
                {bismillah}

                <ListGroup variant="flush">
                  {data.map(d => (
                    <ListGroup.Item className="ayat" key={d.aya_id}>
                      <span className="arab">{d.aya_text}</span>
                      <p className="terjemah">{d.translation_aya_text}</p>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
                <Footer />
              </Col>
            </Row>
          </Container>
        )
      }
    </>
  )
}

export default SurahComponent